import { configureStore, createSlice } from "@reduxjs/toolkit";

const cartReducer=createSlice({
    name:"cart",
    initialState:{},
    reducers:{
        addToCart(state,action){
            if(!state[action.payload]){
               return state={...state,[action.payload]:1}
            }
            else{
               return state={...state,[action.payload]:state[action.payload]+1}
            }
        },
        removeFromCart(state,action){
           return state={...state,[action.payload]:state[action.payload]-1}
        },
        completeRemove(state,action){
            return state={...state,[action.payload]:0}
        }
    }
});

const store=configureStore({reducer:cartReducer.reducer});
export default store;
export const action=cartReducer.actions